import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/common/modal-component';
import { FormattedMessage } from 'react-intl';
import { ModalButton } from 'models/utils/common/modal-button-model';
import Banner, { BANNER_TYPES } from 'components/common/banner-component';

const OMNIA_FILE_SHARING_CONFIRM_MODAL_ID = 'file-export-in-progess-modal-id';
const STATEMENT_EXPORT_MODAL_BLOCK = 'statement-export-modal';

const StatementExportInProgressModal = ({ onClickClose, title, message, isOpmDown = false }) => {
  return (
    <Modal
      id={OMNIA_FILE_SHARING_CONFIRM_MODAL_ID}
      title={title}
      onClose={onClickClose}
      primaryModalButton={
        new ModalButton({
          text: 'common.close',
          onClick: onClickClose,
        })
      }
    >
      {isOpmDown && (
        <div className={`${STATEMENT_EXPORT_MODAL_BLOCK}__banner`}>
          <Banner
            id={`${STATEMENT_EXPORT_MODAL_BLOCK}-opm-warning-banner`}
            type={BANNER_TYPES.WARNING}
            bannerCopy={'export-workpaper-modal.opm-down-warning'}
            isInternationalized={true}
            isInteractive={false}
            width={'100%'}
          />
        </div>
      )}
      <div>
        <FormattedMessage id={message} />
      </div>
    </Modal>
  );
};

StatementExportInProgressModal.propTypes = {
  /** Action fired when user clicks No || close button */
  onClickClose: PropTypes.func.isRequired,
  /** internationalized string title of the modal */
  title: PropTypes.string.isRequired,
  /** internationalized string - confirmation message*/
  message: PropTypes.string.isRequired,
  /** Boolean indicating if OPM service is down */
  isOpmDown: PropTypes.bool,
};

export default StatementExportInProgressModal;
